module.exports = __webpack_public_path__ + "static/media/Tuto_acceder_a_la_visio_par_le_site.6e01890c.pdf";